export default __webpack_public_path__ + "static/media/icon_message-3.1c70a0fc.svg";